import React from "react";
import { Link } from "react-router-dom";
import "./ServicePage.css";

// Service Icons
function TruckIcon({ size = 24, color = "#d19e90" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="1" y="3" width="15" height="13"/>
      <polygon points="16,8 20,8 23,11 23,16 16,16"/>
      <circle cx="5.5" cy="18.5" r="2.5"/>
      <circle cx="18.5" cy="18.5" r="2.5"/>
    </svg>
  );
}

function ShieldIcon({ size = 24, color = "#d19e90" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
    </svg>
  );
}

function CheckCircleIcon({ size = 24, color = "#d19e90" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
      <polyline points="22,4 12,14.01 9,11.01"/>
    </svg>
  );
}

function HeadphonesIcon({ size = 24, color = "#d19e90" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 14v3a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2z"/>
      <path d="M21 14v3a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h1a2 2 0 0 1 2 2z"/>
      <path d="M7 14v3a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2z"/>
    </svg>
  );
}

function StarIcon({ size = 24, color = "#d19e90" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26"/>
    </svg>
  );
}

function CreditCardIcon({ size = 24, color = "#d19e90" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="1" y="4" width="22" height="16" rx="2" ry="2"/>
      <line x1="1" y1="10" x2="23" y2="10"/>
    </svg>
  );
}

function ClockIcon({ size = 24, color = "#d19e90" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"/>
      <polyline points="12,6 12,12 16,14"/>
    </svg>
  );
}

function GiftIcon({ size = 24, color = "#d19e90" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="20,12 20,22 4,22 4,12"/>
      <rect x="2" y="7" width="20" height="5"/>
      <line x1="12" y1="22" x2="12" y2="7"/>
      <path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/>
      <path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/>
    </svg>
  );
}

export default function ServicePage() {
  return (
    <div className="mariamly-service-page">
      {/* Banner Section */}
      <div className="service-banner">
        <div className="service-banner-content">
          <h1 className="service-banner-title">Our Services</h1>
          <div className="service-breadcrumb">
            <Link to="/">Home</Link>
            <span>/</span>
            <span>Services</span>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="service-content">
        {/* Introduction Section */}
        <div className="service-intro">
          <h2>At Mariamly Luxe, we don't just sell cosmetics—we deliver an elegant shopping experience</h2>
          <p>
            We are committed to providing you with exceptional service that matches the quality of our premium beauty products. 
            From the moment you browse our collection to the day your order arrives at your doorstep, we ensure every step 
            of your journey is seamless, secure, and satisfying.
          </p>
        </div>

        {/* Service Features */}
        <div className="service-features">
          <h3>Our Service Promise</h3>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">
                <TruckIcon size={40} />
              </div>
              <h4>Luxury Delivered</h4>
              <p>Fast, reliable, and secure shipping to your doorstep. We partner with trusted carriers to ensure your beauty products arrive safely and on time.</p>
              <ul className="feature-list">
                <li>Free shipping on orders over $50</li>
                <li>Express delivery options available</li>
                <li>Real-time tracking for all orders</li>
                <li>Secure packaging to protect your products</li>
              </ul>
            </div>

            <div className="feature-card">
              <div className="feature-icon">
                <ShieldIcon size={40} />
              </div>
              <h4>Safe & Simple Shopping</h4>
              <p>Easy browsing with trusted payment options and secure checkout process. Your personal and financial information is always protected.</p>
              <ul className="feature-list">
                <li>SSL encrypted secure checkout</li>
                <li>Multiple trusted payment methods</li>
                <li>Guest checkout available</li>
                <li>PCI compliant payment processing</li>
              </ul>
            </div>

            <div className="feature-card">
              <div className="feature-icon">
                <CheckCircleIcon size={40} />
              </div>
              <h4>Authenticity Guaranteed</h4>
              <p>Every product is 100% original and carefully selected. We work directly with authorized distributors and brands to ensure authenticity.</p>
              <ul className="feature-list">
                <li>Direct brand partnerships</li>
                <li>Authorized distributor network</li>
                <li>Quality assurance checks</li>
                <li>Authenticity certificates included</li>
              </ul>
            </div>

            <div className="feature-card">
              <div className="feature-icon">
                <HeadphonesIcon size={40} />
              </div>
              <h4>Customer Care</h4>
              <p>Our dedicated team is always ready to assist with any questions or product advice. We're here to help you find the perfect beauty solutions.</p>
              <ul className="feature-list">
                <li>24/7 customer support</li>
                <li>Expert beauty consultations</li>
                <li>Product recommendations</li>
                <li>Easy returns and exchanges</li>
              </ul>
            </div>

            <div className="feature-card">
              <div className="feature-icon">
                <StarIcon size={40} />
              </div>
              <h4>Beauty Exclusives</h4>
              <p>Be the first to know about new arrivals, limited editions, and luxury beauty trends. Get exclusive access to special collections.</p>
              <ul className="feature-list">
                <li>Early access to new launches</li>
                <li>Limited edition collections</li>
                <li>Exclusive member discounts</li>
                <li>Trend alerts and beauty tips</li>
              </ul>
            </div>

            <div className="feature-card">
              <div className="feature-icon">
                <GiftIcon size={40} />
              </div>
              <h4>Special Services</h4>
              <p>Enjoy additional services designed to enhance your beauty shopping experience with personalized touches and special offerings.</p>
              <ul className="feature-list">
                <li>Gift wrapping services</li>
                <li>Personalized beauty consultations</li>
                <li>Subscription boxes available</li>
                <li>Loyalty rewards program</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Service Highlights */}
        <div className="service-highlights">
          <div className="highlights-content">
            <h3>Why Choose Our Services?</h3>
            <div className="highlights-grid">
              <div className="highlight-item">
                <ClockIcon size={32} />
                <div className="highlight-text">
                  <h4>Fast Processing</h4>
                  <p>Orders processed within 24 hours of confirmation</p>
                </div>
              </div>
              <div className="highlight-item">
                <CreditCardIcon size={32} />
                <div className="highlight-text">
                  <h4>Secure Payments</h4>
                  <p>Multiple secure payment options with fraud protection</p>
                </div>
              </div>
              <div className="highlight-item">
                <ShieldIcon size={32} />
                <div className="highlight-text">
                  <h4>Quality Assurance</h4>
                  <p>Every product inspected before shipping</p>
                </div>
              </div>
              <div className="highlight-item">
                <HeadphonesIcon size={32} />
                <div className="highlight-text">
                  <h4>Expert Support</h4>
                  <p>Beauty experts ready to help with your needs</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Contact Support */}
        <div className="service-support">
          <div className="support-content">
            <h3>Need Help? We're Here for You</h3>
            <p>
              Our customer service team is dedicated to providing you with the best possible experience. 
              Whether you have questions about products, need help with an order, or want beauty advice, 
              we're just a click or call away.
            </p>
            <div className="support-options">
              <a href="mailto:info@mariamlyluxe.com" className="support-button">
                <HeadphonesIcon size={20} />
                <span>Email Support</span>
              </a>
              <a href="tel:+96170457945" className="support-button">
                <HeadphonesIcon size={20} />
                <span>Call Us</span>
              </a>
              <Link to="/contact" className="support-button">
                <HeadphonesIcon size={20} />
                <span>Contact Form</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
